"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_1 = require("@icr-ui/icons");
const react_1 = require("react");
const styles_1 = require("./styles");
exports.Button = (0, react_1.forwardRef)((props, ref) => {
    const renderChildren = () => {
        const { iconButton, endAdornment, startAdornment, children, isLoading = false, } = props;
        if (endAdornment || startAdornment || isLoading) {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [iconButton && isLoading ? (0, jsx_runtime_1.jsx)(icons_1.LoaderIcon, { width: "40", height: "40" }) : children, isLoading && !iconButton ? ((0, jsx_runtime_1.jsx)(icons_1.LoaderIcon, { width: "40", height: "40" })) : (endAdornment || startAdornment)] }));
        }
        return children;
    };
    const renderButton = () => {
        const { disabled, variant, isLoading } = props;
        if (isLoading || (disabled && variant !== 'info')) {
            return ((0, jsx_runtime_1.jsx)(styles_1.StyledDisabledButton, { ...{ ref, ...props }, onClick: (e) => e.preventDefault(), children: renderChildren() }));
        }
        if (variant === 'inverted') {
            return ((0, jsx_runtime_1.jsx)(styles_1.StyledInvertedButton, { ...{ ref, ...props }, children: renderChildren() }));
        }
        if (variant === 'info') {
            return ((0, jsx_runtime_1.jsx)(styles_1.StyledInfoDiv, { "data-testid": "button-info-wrapper", ...{ ref, ...props }, children: (0, jsx_runtime_1.jsx)(styles_1.StyledInfoButton, { "data-testid": "button-info", ...{ ref, ...props }, onClick: (e) => (disabled ? e.preventDefault() : null), children: renderChildren() }) }));
        }
        return ((0, jsx_runtime_1.jsx)(styles_1.StyledVariantButton, { ...{ ref, ...props }, children: renderChildren() }));
    };
    return renderButton();
});
exports.Button.displayName = 'Button';
exports.default = exports.Button;
//# sourceMappingURL=button.js.map